




















import Vue from "vue";
import Component from "vue-class-component";
import BaseIcon from "@/components/BaseIcon";
import BaseInputFile from "@/components/BaseInputFile";

@Component({ name: "ImageUpload", components: { BaseInputFile, BaseIcon } })
export default class ImageUpload extends Vue {}
